<ng-container *ngIf="items$ | async as items">
  <div *ngIf="items.length > 0" class="container js-product-carousel" [attr.data-name]="title$ | async">
    <label [ngClass]="activeLanguage$ | async">{{ title$ | async }}</label>
    <app-product-carousel-normal
      *ngIf="normal"
      [items$]="items$"
      [dealerPrices]="dealerPrices"
      [location]="carouselLocation"
    ></app-product-carousel-normal>
    <app-product-carousel-big *ngIf="!normal" [items]="items" [dealerPrices]="dealerPrices"></app-product-carousel-big>
  </div>
</ng-container>
